import { MockShell } from './MockShell'

const LINES: Array<{ k: string; v: string; muted?: boolean }> = [
  { k: 'Aralyk · 1,240 km', v: '—', muted: true },
  { k: 'Ýangyç · 320 L @ €1.62', v: '€ 518.40' },
  { k: 'Paçlar · DE + PL', v: '€ 184.00' },
  { k: 'Sürüji · 2 gün', v: '€ 420.00' },
  { k: 'Rugsatlar we tölegler', v: '€  36.00' },
]

export function CalculationMock() {
  return (
    <MockShell title="Göni senariýasy · Hasaplama">
      <div className="p-5">
        <div className="rounded-xl border border-border overflow-hidden">
          <div className="px-4 py-2 border-b border-border bg-muted/30 flex items-center justify-between text-[11px]">
            <span className="text-overline text-muted-foreground">Çykdajy setirleri</span>
            <span className="text-muted-foreground">EUR</span>
          </div>
          <div className="divide-y divide-border text-[13px]">
            {LINES.map((l) => (
              <div
                key={l.k}
                className="px-4 py-2.5 flex items-center justify-between"
              >
                <span className={l.muted ? 'text-muted-foreground' : 'text-foreground'}>
                  {l.k}
                </span>
                <span
                  className={'tnum ' + (l.muted ? 'text-muted-foreground' : 'text-foreground')}
                >
                  {l.v}
                </span>
              </div>
            ))}
            <div className="px-4 py-2.5 flex items-center justify-between bg-muted/30 font-medium">
              <span>Jemi çykdajy</span>
              <span className="tnum">€ 1,158.40</span>
            </div>
          </div>
        </div>

        <div className="mt-4 rounded-xl border border-border overflow-hidden">
          <div className="px-4 py-2 border-b border-border bg-muted/30 text-overline text-muted-foreground">
            Bahalama
          </div>
          <div className="divide-y divide-border text-[13px]">
            <div className="px-4 py-2.5 flex items-center justify-between">
              <span className="text-muted-foreground">Üstüne goşma</span>
              <span className="tnum">22%</span>
            </div>
            <div className="px-4 py-2.5 flex items-center justify-between">
              <span className="text-muted-foreground">Marja</span>
              <span className="tnum text-positive">+ € 254.85</span>
            </div>
            <div className="px-4 py-3 flex items-center justify-between bg-primary/5 font-semibold">
              <span>Teklip baha</span>
              <span className="tnum text-primary">€ 1,413.25</span>
            </div>
          </div>
        </div>

        <p className="mt-3 text-[11px] text-muted-foreground">
          Her setir üýtgedilýär. Jemi dessine gaýtadan hasaplanýar.
        </p>
      </div>
    </MockShell>
  )
}
